/**
 * @generated SignedSource<<16b92f4343650dc7462bcdf462024fa8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type placementsFetchProductNameQuery$variables = {
  id: string;
};
export type placementsFetchProductNameQuery$data = {
  readonly model: {
    readonly id: string;
    readonly name: string;
  } | null;
};
export type placementsFetchProductNameQuery = {
  response: placementsFetchProductNameQuery$data;
  variables: placementsFetchProductNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Model",
    "kind": "LinkedField",
    "name": "model",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "placementsFetchProductNameQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "placementsFetchProductNameQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9dc8b52bd4eb9ec97d3d6a36ef8cb238",
    "id": null,
    "metadata": {},
    "name": "placementsFetchProductNameQuery",
    "operationKind": "query",
    "text": "query placementsFetchProductNameQuery(\n  $id: ID!\n) {\n  model(id: $id) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "ecc43392a2e5ca46e4d005b24661edd0";

export default node;
